import { render, staticRenderFns } from "./CPDueDiligenceAccountHolderEmploymentDetails.vue?vue&type=template&id=745013e7&scoped=true&"
import script from "./CPDueDiligenceAccountHolderEmploymentDetails.vue?vue&type=script&lang=ts&"
export * from "./CPDueDiligenceAccountHolderEmploymentDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745013e7",
  null
  
)

export default component.exports